var $ = require('jquery');

var LocationMap = function LocationMap($element, options) {
	var $mapElement = $('.location-gmap');

	if($mapElement.length) {
		var position = $.map($mapElement.attr('data-location').split(','), function(val) { return parseFloat(val); });
		
		var gmap = new google.maps.Map($mapElement[0], {
			center: {lat: position[0], lng: position[1]},
			zoom: 13,
			scrollwheel: false,
			mapTypeControlOptions: {
				position: google.maps.ControlPosition.RIGHT_TOP
			},
			zoomControlOptions: {
				position: google.maps.ControlPosition.RIGHT_CENTER
			}
		});

		var gmark = new google.maps.Marker({
			position: {
				lat: position[0],
				lng: position[1]
			},
			map: gmap,
			icon: __CONFIG__.url + 'wp-content/themes/' + __CONFIG__.theme + '/images/custom-pin.png'
		});

		var info = new google.maps.InfoWindow({
			content: $mapElement.attr('data-title')
		});

		info.open(gmap, gmark);

		info.addListener('domready', function() {
			$('.gm-style-iw').addClass('-third').prev().remove();
		});

		gmap.panBy(-200, 0);
	}
}

module.exports = LocationMap;